export default __webpack_public_path__ + "static/media/clothes.a4852ace.jpg";